import { React, PropTypes, styled, css } from '../lib/imports';
import { Image, Heading, Text } from '../components';
import { NavLink } from 'react-router-dom';

export const ImageContainer = styled.div`
  width: ${(props) => `${props.width}`};
  margin-bottom: ${(props) => `${props.bottomMargin}`};
  margin-right: ${(props) => `${props.rightMargin}`};
  margin-left: ${(props) => `${props.leftMargin}`};
`;

const BannerWrapper = styled.section`
  background: ${({ theme }) => theme.colors.headerBg};
  ${({ theme }) => `padding: 0 0 ${theme.spacings.mega} 0;`}
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const TextColumn = styled.section`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  width: 49%;
  margin-left: ${({ theme }) => theme.spacings.giga};
`;

const headingBaseStyles = ({ theme }) => css`
  font-size: ${theme.typography.headings.mega.fontSize};
  line-height: ${theme.typography.headings.deca.lineHeight};
  font-weight: bold;
  margin-bottom: ${theme.spacings.byte};
  margin-top: 0;
`;

const DateWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: ${({ theme }) => theme.spacings.giga};
  margin-bottom: ${({ theme }) => theme.spacings.byte};
`;

const dateTextBaseStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  font-size: ${theme.typography.subHeadings.byte.fontSize};
  line-height: ${theme.typography.subHeadings.byte.fontSize};
  padding-top: ${theme.spacings.atom};
`;

const StatusWrapper = styled.section`
  display: flex;
  align-self: center;
  width: 55%;
  justify-content: space-around;
`;

const Badge = styled.div`
  background-color: ${(props) => props.theme.colors[props.color]};
  border-radius: 12px;
  font-size: 10px;
  font-weight: 900;
  padding: ${({ theme }) => `5px ${theme.spacings.byte} 3px ${theme.spacings.byte}`};
  display: flex;
  align-items: center;
  line-height: 10px;
  text-align: center;
`;

const ImageColumn = styled.section`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 47%;
  justify-content: center;
  align-items: center;
`;

const textBaseStyles = ({ theme }) => css`
  color: ${theme.colors.white};
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.bit.lineHeight};
  font-weight: 400;
  margin-bottom: 0;
`;

const linkBaseStyles = ({ theme }) => css`
  color: ${theme.colors.white};
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.bit.lineHeight};
`;

const AllImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: min-content;
`;

const StyledDateText = styled(Text)(dateTextBaseStyles);

const StyledHeading = styled(Heading)(headingBaseStyles);
const StyledParagraph = styled(Text)(textBaseStyles);
const StyledLink = styled(NavLink)(linkBaseStyles);
const StyledTextBlock = styled.div`
  ${textBaseStyles}
`;
const LeaderboardBanner = ({ text, images, inProgressText, completedText, showAsCompleted, language }) => {
  return (
    <BannerWrapper>
      <TextColumn>
        <StyledHeading>{text.header}</StyledHeading>
        <DateWrapper>
          <StyledDateText>{text.date}</StyledDateText>
          <StatusWrapper>
            {showAsCompleted && <Badge color='n600'>{completedText}</Badge>}
            {!showAsCompleted && <Badge color='g900'>{inProgressText}</Badge>}
          </StatusWrapper>
        </DateWrapper>
        {text.link && (
          <StyledTextBlock>
            <StyledParagraph style={{ width: `${language === 'en' ? '90%' : '100%'}` }}>
              {text.paragraph}
            </StyledParagraph>
            <StyledLink
              to='/game-info'
              onClick={() => {
                const layout = document.getElementById('thLayout');
                if (layout) layout.scrollTo(0, 0);
              }}
            >
              {text.link}
            </StyledLink>
          </StyledTextBlock>
        )}
        {!text.link && <StyledParagraph>{text.paragraph}</StyledParagraph>}
      </TextColumn>
      <ImageColumn>
        <AllImagesWrapper>
          {images.map((image, i) => (
            <ImageContainer
              key={i}
              width={image.width}
              bottomMargin={image.bottomMargin}
              rightMargin={image.rightMargin}
              leftMargin={image.leftMargin}
            >
              <Image src={image.src} />
            </ImageContainer>
          ))}
        </AllImagesWrapper>
      </ImageColumn>
    </BannerWrapper>
  );
};

LeaderboardBanner.propTypes = {
  text: PropTypes.shape({
    header: PropTypes.string,
    date: PropTypes.string,
    paragraph: PropTypes.string,
  }),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.string,
      bottomMargin: PropTypes.string,
      rightMargin: PropTypes.string,
    }),
  ),
  inProgressText: PropTypes.string,
  completedText: PropTypes.string,
  showAsCompleted: PropTypes.boolean,
};

export default LeaderboardBanner;
